export class User {
    username: string;
    color: string;
    isEditing: boolean;
    level: string;
    portfolioId: string;
    key: string;
    row: number;
    date: string[];
    columns: number[];

    initialize() {
        this.isEditing = false;
        this.level = undefined;
        this.key = undefined;
        this.row = undefined;
        this.date = [];
        this.columns = [];
    }
}




// WEBPACK FOOTER //
// ./src/app/core/models/user.ts